import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import {sanitizeContent} from 'js/shared/security';

import './offerDurationBanner.scss'

const OfferDurationBanner = ({ isOffers = false, text = '' }) => (
  <div
    className={cn('offer-duration-widget', { isOffers })}
  >
    <div
      className="offer-duration"
    >
      <div className="offer-duration__logo" />
      <div className="offer-duration__text" dangerouslySetInnerHTML={{ __html: sanitizeContent(text) }} />
    </div>
  </div>
)

OfferDurationBanner.propTypes = {
  isOffers: PropTypes.bool,
  text: PropTypes.string.isRequired,
}

export default OfferDurationBanner
